import { Actions, UseClassroomState } from './types';

export const defaultState = (): UseClassroomState => ({
  classrooms: [],
  activeClassroom: {} as any,
  isLoading: false,
});

export const reducers = (state: UseClassroomState, action: Actions): UseClassroomState => {
  switch (action.type) {
    case 'SET_ACTIVE_CLASSROOM':
      return { ...state, activeClassroom: action.payload.classroom };
    case 'SET_CLASSROOMS':
      return { ...state, classrooms: action.payload.classrooms };
    case 'SET_LOADING':
      return { ...state, isLoading: action.payload.isLoading };
  }
};
